import { call, put, select } from 'redux-saga/effects';

import { updateMapping } from '@api/mapping';
import { conversionToolUpdateSelection } from '@models/ConversionTool/conversionToolUpdateSelection';
import { history, jurisdictionsRoutes } from '@routes';
import {
  conversionToolMappingEditFailureAction,
  conversionToolMappingEditSuccessAction,
} from '@store/conversionTool/conversionToolMappingEdit/conversionToolMappingEdit.actions';
import { toastError, toastSuccess } from '@store/notifications';
import { mappingEdit } from '@store/selectors/conversionTool/mappingEdit';

export const conversionToolMappingEditSaga = function* ({ payload = {} }) {
  try {
    const mappingData = yield select(mappingEdit);
    const { entityId, name, rowStart, ...columns } = payload;

    yield call(updateMapping, {
      mappingId: mappingData.id,
      data: {
        ...mappingData,
        name,
        rowStart,
        columnMap: conversionToolUpdateSelection(columns),
      },
    });

    yield put([
      toastSuccess({
        message: {
          defaultMessage: 'Mapping updated successfully.',
          id: 'components.mapping-edit-page.update.success',
        },
      }),
      conversionToolMappingEditSuccessAction(),
    ]);

    yield call(
      history.push,
      jurisdictionsRoutes.MAPPING.make(entityId, mappingData.entityJurisdiction)
    );
  } catch (errors) {
    const { nonFieldErrors } = errors?.data || {};
    yield put([
      toastError({
        message: nonFieldErrors || {
          defaultMessage: 'Failed to update the mapping',
          id: 'components.mapping-edit-page.api-update-error',
        },
      }),
      conversionToolMappingEditFailureAction(),
    ]);
  }
};
